import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'selectionStyling'
})
export class SelectionStylingPipe implements PipeTransform {
  colorList = {
    0: 'green', 1: 'aqua', 2: 'orange', 3: 'red', 4: 'purple', 5: 'fuchsia',
    6: 'gray', 7: 'navy', 8: 'blue'
  };
  transform(selectedCustomers: any[], selected): string {
    console.log('selectedCustomers', selectedCustomers);
    console.log('selectedCustomers', selected);
    // get value from coloList due to the index of the selectedCustomer
    const color = this.colorList[selectedCustomers.indexOf(selected.nzValue)];
    const className = `bg-color-${color}`;
    return className;
  }

}
